import MonitoringQueueEntryScoringDetailsTableRow from './MonitoringQueueEntryScoringDetailsTableRow';

export default MonitoringQueueEntryScoringDetailsTableRow;


// WEBPACK FOOTER //
// ./src/features/monitoring-queue-entry/components/scoring/scoring-details-table/row/index.js